<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Detalle de cortes</h4>
      <p class="card-category">{{ filas.length }} corte(s) · duración mayor a {{ minFiltro }} min</p>
    </div>
    <div class="card-body">
      <div class="cg-scroll">
        <table class="table cg-tabla">
          <thead>
            <tr>
              <th>Unidad</th>
              <th>Inicio del corte</th>
              <th>Fin / reenganche</th>
              <th>Duración</th>
              <th>Estado</th>
              <th>Dónde perdió señal</th>
              <th>Mapa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filas.length">
              <td colspan="7" class="cg-vacio">
                Ninguno de los cortes del período supera los {{ minFiltro }} minutos.
                Bajá el umbral con la barra de arriba para ver los más cortos.
              </td>
            </tr>
            <tr v-for="(f, i) in filas" :key="i">
              <td>
                <i class="cg-sw" :style="{ background: f.hex }"></i>
                <b>{{ f.alias }}</b>
                <span v-if="f.patente && f.patente !== f.alias" class="cg-mono cg-sec">{{ f.patente }}</span>
              </td>
              <td class="cg-mono">{{ f.inicio }}</td>
              <td class="cg-mono">{{ f.fin }}</td>
              <td class="cg-mono">{{ f.duracion }}</td>
              <td>{{ f.estado }}</td>
              <td class="cg-mono cg-sec">{{ f.coord }}</td>
              <td>
                <button
                  v-if="f.tieneMapa"
                  type="button"
                  class="btn btn-default btn-xs"
                  @click="$emit('ver-tramo', f.uid, f.t0, f.t1)"
                >
                  ver tramo
                </button>
                <span v-else>—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="cg-nota">
        <b>Ojo con la lectura:</b> un "corte" es todo período <b>sin reporte</b> mayor al umbral
        elegido. Incluye pérdida real de señal GSM, pero también la unidad <b>apagada</b> o con la
        <b>batería externa desconectada</b>. Los cortes <b>en curso</b> se miden hasta el fin del
        período.
      </p>
    </div>
  </div>
</template>

<script>
import { cortesFiltrados, fmtCoord, fmtDT, fmtDur } from "./cobertura";

export default {
  name: "TablaCortes",
  props: {
    unidades: { type: Array, required: true },
    minFiltro: { type: Number, default: 20 },
  },
  computed: {
    filas() {
      const out = [];
      this.unidades.forEach((u) => {
        cortesFiltrados(u, this.minFiltro).forEach((c) => {
          out.push({
            uid: u.uid,
            hex: u.hex,
            alias: u.alias,
            patente: u.patente,
            inicio: fmtDT(c.ini),
            fin: fmtDT(c.fin),
            duracion: fmtDur(c.dur),
            estado: c.estado,
            coord: fmtCoord(c.lat, c.lon),
            tieneMapa: u.puntos.length > 0,
            t0: c.t0,
            t1: c.t1,
            orden: c.t0,
          });
        });
      });
      return out.sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style scoped>
.cg-scroll {
  max-height: 440px;
  overflow: auto;
  border: 1px solid var(--cg-line);
  border-radius: 6px;
}
.cg-tabla {
  margin-bottom: 0;
  font-size: 13.5px;
}
.cg-tabla th {
  font-family: var(--cg-font-mono);
  font-size: 9.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cg-muted);
  position: sticky;
  top: 0;
  background: var(--cg-surface);
  z-index: 1;
}
.cg-tabla td {
  vertical-align: middle;
}
.cg-mono {
  font-family: var(--cg-font-mono);
  font-variant-numeric: tabular-nums;
}
.cg-sec {
  opacity: 0.65;
  margin-left: 6px;
}
.cg-sw {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 7px;
  vertical-align: middle;
}
.cg-vacio {
  color: var(--cg-muted);
  padding: 18px 10px;
}
.cg-nota {
  font-size: 12.5px;
  color: var(--cg-muted);
  margin-top: 12px;
  line-height: 1.55;
}
.cg-nota b {
  color: var(--cg-text);
  font-weight: 500;
}
</style>
